import "./WadeReportMonthPage.css";

export default function WadeReportMonthPageNew () {

    return (
        <div className="WadeReportMonthPageNew">
            Månedlig rapportering er under vedligeholdelse.
        </div>
    )
}